import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Header } from './components/header';
import { Loading } from './components/loading';
import { CustomerGroupCard } from './components/group-card';
import styles from './components/styles.module.scss';
export var CustomerGroupsView = function (_a) {
    var isLoading = _a.isLoading, customerGroups = _a.customerGroups;
    return (_jsxs("div", { className: "u-mb-", children: [_jsx(Header, {}), isLoading && _jsx(Loading, {}), !isLoading && (_jsx("div", { className: styles['cards-container'], children: customerGroups.map(function (customerGroup) { return (_jsx(CustomerGroupCard, { customerCount: customerGroup.customers, groupName: customerGroup.name }, customerGroup.name)); }) }))] }));
};
